import React from "react";
import { MyPageHead } from "components/pages/myPage/common";
import {
  MarketFlowerListContainer,
  MarketFlowersList,
  MarketFlowerItem,
  MarketFlowerWrapper,
} from "./MarketFlowerListStyle";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MarketCreators } from "redux/modules/market";

const MarketFlowerList = () => {
  const { marketId, type } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const pageTitle =
    type === "today-flowers" ? "오늘 들어온 생화" : "최근 한달간 판매한 생화";

  const todayFlowers = useSelector((state) => state.market.todayFlowers);
  const monthlyFlowers = useSelector((state) => state.market.monthlyFlowers);

  useEffect(() => {
    if (type === "today-flowers") {
      dispatch(MarketCreators.fetchTodayFlowers(marketId));
      return;
    }
    dispatch(MarketCreators.fetchMonthlyFlowers(marketId));
  }, []);

  return (
    <MarketFlowerWrapper>
      <MyPageHead title={pageTitle} />
      <MarketFlowerListContainer>
        <MarketFlowersList>
          {type === "today-flowers"
            ? todayFlowers.data?.map((item, index) => {
                return (
                  <MarketFlowerItem
                    key={index}
                    onClick={() => {
                      navigate(`/market/image-preview`);
                      localStorage.setItem(
                        "floway-flower-preview",
                        item.flowerImg
                      );
                    }}
                  >
                    <img src={item.flowerImg} alt="flower" />
                    <p>{item.flowerName}</p>
                  </MarketFlowerItem>
                );
              })
            : null}

          {type === "monthly-flowers"
            ? monthlyFlowers.data?.map((item, index) => {
                return (
                  <MarketFlowerItem
                    key={index}
                    onClick={() => {
                      navigate(`/market/image-preview`);
                      localStorage.setItem(
                        "floway-flower-preview",
                        item.flowerImg
                      );
                    }}
                  >
                    <img src={item.flowerImg} alt="flower" />
                    <p>{item.flowerName}</p>
                  </MarketFlowerItem>
                );
              })
            : null}
        </MarketFlowersList>
      </MarketFlowerListContainer>
    </MarketFlowerWrapper>
  );
};

export default MarketFlowerList;
